import { Icon } from '@rsuite/icons';
import React, { memo, useEffect, useState } from 'react';
import {
  Button,
  Col,
  FlexboxGrid,
  IconButton,
  Loader,
  Message,
  Modal,
  Stack,
  Tooltip,
  Uploader,
  useToaster,
  Whisper
} from 'rsuite';
import Cropper from '../Cropper';
import ReloadIcon from '@rsuite/icons/Reload';
import BlockIcon from '@rsuite/icons/Block';
import SortDownIcon from '@rsuite/icons/SortDown';
import ZoomoutIcon from '@rsuite/icons/Zoomout';
import UndoIcon from '@rsuite/icons/Undo';
import ScatterIcon from '@rsuite/icons/Scatter';
import CameraRetroIcon from '@rsuite/icons/legacy/CameraRetro';
import TrashIcon from '@rsuite/icons/Trash';
import EditIcon from '@rsuite/icons/Edit';
import globalIP from '@/GlobelIP';
import Port from '@/Port';
import useUser from '../../../../components/UseUser';
import imageCompression from "browser-image-compression";
import AntdImageUploader from './AntdImageUpload';

const { hostname } = window.location;
// const hostname = '192.168.1.19';

const ImageSection = ({
  setFileInfo,
  orginalImg,
  setOrginalImg,
  setMultiImgScroll,
  setData5,
  setName,
  compndata,
  setNum,
  fileInfo,
  setNum1,
  data5,
  name,
  setDataimg,
  dataimg,
  setUpdateId,
  data51,
  setData51,
  resizeFile,
  base64ToBlob,
  setProcessing,
  processing
}) => {

  const { user } = useUser();
  const toaster = useToaster();
  const [hovered, setHovered] = React.useState(null);
  const [loadingMultipleimg, setLoadingMultipleimg] = useState(false);

  const [openImageEditModal, setopenImageEditModal] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);
  const [watermarkImg, setWatermarkImg] = useState(null);
  const [editCount, setEditCount] = useState(0);
  const [isCropping, setIsCropping] = useState(false);
  const handleCropping = () => {
    setEditCount(1);
    setIsCropping(!isCropping);
  };

  const preloadWatermarkImage = async () => {
    const watermarkUrl = `${globalIP}${compndata[0]?.attributes?.WaterMark?.data?.attributes?.url}`; // Replace with your API URL
    const img = new Image();
    img.crossOrigin = 'anonymous'; // Enable CORS if needed
    img.src = watermarkUrl;

    return new Promise((resolve, reject) => {
      img.onload = () => resolve(img);
      img.onerror = err => reject('Error loading watermark image: ' + err);
    });
  };

  const [closingopenEditModal, setClosingOpenEditModal] = React.useState(false);

  const handleopenImageEditModal = () => setopenImageEditModal(true);
  const handleCloseImageEditModal = async () => {
    setClosingOpenEditModal(true);
    setEditCount(0);
    if (fileInfo && rotationDegrees) {
      await urlToFile();
    }
    setopenImageEditModal(false);
    setClosingOpenEditModal(false);
  };

  // const handleImageUpload = fileList => {
  //   if (fileList.length > 0) {
  //     setUploading(true);
  //     const lastIndex = fileList.length - 1;
  //     const file = fileList[lastIndex];
  //     const allowedExtensions = ['jpg', 'jpeg'];
  //     const fileExtension = file.name.split('.').pop().toLowerCase();
  //     setName(file.name);

  //     if (allowedExtensions.includes(fileExtension)) {
  //       const originalBlob = file.blobFile || file;
  //       const fileReader = new FileReader();

  //       fileReader.onload = event => {
  //         const img = new Image();
  //         img.src = event.target.result;

  //         img.onload = async () => {
  //           const watermarkEnabled = compndata[0]?.attributes?.WMark === true;

  //           const canvas = document.createElement('canvas');
  //           const ctx = canvas.getContext('2d');
  //           canvas.width = img.width;
  //           canvas.height = img.height;
  //           ctx.drawImage(img, 0, 0);

  //           if (watermarkEnabled && watermarkImg) {
  //             const watermarkWidth = img.width * 0.3;
  //             const watermarkHeight = (watermarkImg.height / watermarkImg.width) * watermarkWidth;
  //             const watermarkX = (canvas.width - watermarkWidth) / 2;
  //             const watermarkY = (canvas.height - watermarkHeight) / 2;

  //             ctx.globalAlpha = 0.3; // ✅ Proper opacity between 0 and 1
  //             ctx.drawImage(watermarkImg, watermarkX, watermarkY, watermarkWidth, watermarkHeight);
  //           }

  //           // Export canvas with controlled compression
  //           finalizeCanvas(canvas, 'image/jpeg'); // force jpeg for compression
  //         };
  //       };

  //       fileReader.readAsDataURL(originalBlob);
  //     } else {
  //       setUploading(false);
  //       toaster.push(
  //         <Message showIcon type="error">
  //           Please change image to jpg/jpeg
  //         </Message>,
  //         { placement: 'topCenter' }
  //       );
  //     }
  //   }
  // };


  //**compressed function */
  const handleImageUpload = async (fileList) => {
    if (fileList.length === 0) return;
    setUploading(true);

    const lastIndex = fileList.length - 1;
    const file = fileList[lastIndex];
    const allowedExtensions = ["jpg", "jpeg"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      setUploading(false);
      toaster.push(
        <Message showIcon type="error">
          Please use JPG or JPEG format.
        </Message>,
        { placement: "topCenter" }
      );
      return;
    }

    try {
      // ✅ Step 1: Compress image before anything else
      const options = {
        maxSizeMB: 1, // Compress to around 1MB
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      const compressedFile = await imageCompression(file.blobFile || file, options);

      // ✅ Step 2: Convert to Image safely
      const imageDataUrl = await imageCompression.getDataUrlFromFile(compressedFile);
      const img = new Image();
      img.src = imageDataUrl;

      img.onload = async () => {
        const watermarkEnabled = compndata[0]?.attributes?.WMark === true;

        // Create optimized canvas
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Keep resolution reasonable (avoid 8k/12k images)
        const maxWidth = 1920;
        const scale = Math.min(1, maxWidth / img.width);
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        // ✅ Step 3: Add watermark if enabled
        if (watermarkEnabled && watermarkImg) {
          const watermarkWidth = canvas.width * 0.3;
          const watermarkHeight = (watermarkImg.height / watermarkImg.width) * watermarkWidth;
          const watermarkX = (canvas.width - watermarkWidth) / 2;
          const watermarkY = (canvas.height - watermarkHeight) / 2;
          ctx.globalAlpha = 0.3;
          ctx.drawImage(watermarkImg, watermarkX, watermarkY, watermarkWidth, watermarkHeight);
        }

        // ✅ Step 4: Export compressed canvas image
        const compressedCanvasBlob = await new Promise((resolve) =>
          canvas.toBlob(resolve, "image/jpeg", 0.8) // 80% quality for faster loading
        );

        // Create a preview
        const previewUrl = URL.createObjectURL(compressedCanvasBlob);
        setFileInfo(previewUrl);
        setName(file.name);

        // Continue your upload logic
        finalizeCanvas(canvas, "image/jpeg");

        setUploading(false);
      };
    } catch (error) {
      console.error("Error processing image:", error);
      setUploading(false);
      toaster.push(
        <Message showIcon type="error">
          Failed to process image.
        </Message>,
        { placement: "topCenter" }
      );
    }
  };
  const finalizeCanvas = async (canvas, fileType) => {
    canvas.toBlob(
      async blob => {
        const previewUrl = URL.createObjectURL(blob);
        setFileInfo(previewUrl); // For preview
        setOrginalImg(blob); // For storage
        setMultiImgScroll(blob);
        setData5(prevData5 => ({
          ...prevData5,
          CoverImage: blob
        }));

        // toaster.push(
        //   <Message showIcon type="success">
        //     Image Upload Successfully
        //   </Message>,
        //   { placement: 'topCenter' }
        // );
        setNum(1);
        setUploading(false);
      },
      fileType, // 'image/jpeg'
      0.6 // ✅ Compression quality (0 to 1), lower = smaller file
    );
  };

  const rotateImage = (imageURL: string, degrees: number): Promise<Blob> => {
    return new Promise((resolve, reject) => {
      const rotatedImage = new Image();
      rotatedImage.crossOrigin = 'Anonymous';
      rotatedImage.src = imageURL;

      rotatedImage.onload = () => {
        try {
          const radians = (degrees * Math.PI) / 180;

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d')!;
          const width = rotatedImage.width;
          const height = rotatedImage.height;

          const newWidth =
            Math.abs(Math.cos(radians) * width) + Math.abs(Math.sin(radians) * height);
          const newHeight =
            Math.abs(Math.sin(radians) * width) + Math.abs(Math.cos(radians) * height);

          canvas.width = newWidth;
          canvas.height = newHeight;

          ctx.translate(newWidth / 2, newHeight / 2);
          ctx.rotate(radians);
          ctx.drawImage(rotatedImage, -width / 2, -height / 2);

          canvas.toBlob(
            blob => {
              if (blob) {
                resolve(blob);
              } else {
                reject(new Error('Blob creation failed'));
              }
            },
            'image/jpeg',
            0.9 // Compression quality (0–1)
          );
        } catch (err) {
          reject(err);
        }
      };

      rotatedImage.onerror = () => reject(new Error('Failed to load image'));
    });
  };

  const [rotationDegrees, setRotationDegrees] = useState(0);
  useEffect(() => {
    urlToFile();
  }, [fileInfo]);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const handleRotateImage2 = () => {
    // Rotate the image by 90 degrees clockwise
    setRotationDegrees2(prevRotation => (prevRotation + 90) % 360);
  };

  const handleRotateImage = () => {
    // Rotate the image by 90 degrees clockwise
    setEditCount(1);
    setRotationDegrees(prevRotation => (prevRotation + 90) % 360);
  };
  const [rotationDegrees2, setRotationDegrees2] = useState(0);
  const [imageDownloading, setImageDownloading] = useState(false)
  const handleDownloadImage = async () => {
    try {
      setImageDownloading(true);

      toaster.push(
        <Message showIcon type="info" duration={2000}>
          Downloading image...
        </Message>,
        { placement: 'topCenter' }
      );

      let fileName = name || data5.CoverImage?.data?.attributes?.name || data5.ProductId;
      fileName = fileName.replace(/\.(png|PNG)$/, '.jpg');
      if (!fileName.toLowerCase().endsWith('.jpg')) fileName += '.jpg';

      rotateImage(fileInfo, rotationDegrees)
        .then(blob => {
          const blobUrl = URL.createObjectURL(blob);

          const downloadLink = document.createElement('a');
          downloadLink.href = blobUrl;
          downloadLink.download = fileName;

          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);

          URL.revokeObjectURL(blobUrl); // cleanup

          toaster.push(
            <Message showIcon type="success" duration={2000}>
              Image downloaded successfully!
            </Message>,
            { placement: 'topCenter' }
          );
        })
        .catch(err => {
          console.error('Error rotating image:', err);
          toaster.push(
            <Message showIcon type="error" duration={3000}>
              Failed to download image.
            </Message>,
            { placement: 'topCenter' }
          );
        })
        .finally(() => {
          setImageDownloading(false);
        });
    } catch (error) {
      console.error('Error during download:', error);
      toaster.push(
        <Message showIcon type="error" duration={3000}>
          Something went wrong while downloading.
        </Message>,
        { placement: 'topCenter' }
      );
      setImageDownloading(false);
    }
  };


  const handleDownloadImage2 = () => {
    const fileName = editimg?.file?.name?.replace(/\.(png|PNG)$/i, '.jpg') || 'download.jpg';
    const downloadLink = document.createElement('a');
    downloadLink.download = fileName.endsWith('.jpg') ? fileName : `${fileName}.jpg`;

    rotateImage(editimgurl, rotationDegrees2)
      .then(blob => {
        const blobUrl = URL.createObjectURL(blob);

        downloadLink.href = blobUrl;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        URL.revokeObjectURL(blobUrl); // Clean up memory
      })
      .catch(err => {
        console.error('Error rotating image:', err);
      });
  };

  const urlToFile = async () => {
    try {
      const blob = await rotateImage(fileInfo, rotationDegrees); // Already returns a compressed Blob

      const file = new File([blob], name.endsWith('.jpg') ? name : `${name}.jpg`, {
        type: 'image/jpeg'
      });

      setData5(prevData => ({
        ...prevData,
        CoverImage: file
      }));

      setNum(1);
    } catch (error) {
      console.error('Error converting rotated image to file:', error);
    }
  };

  const urlToFile2 = async () => {
    try {
      setNum1(1);

      const blob = await rotateImage(editimgurl, rotationDegrees2); // Compressed and rotated Blob

      let fileName = editimg?.file?.name || 'image.jpg';

      // Force .jpg extension
      fileName = fileName.replace(/\.(png|PNG)$/i, '.jpg');
      if (!fileName.toLowerCase().endsWith('.jpg')) {
        fileName += '.jpg';
      }

      const file = new File([blob], fileName, { type: 'image/jpeg' });

      return file;
    } catch (error) {
      console.error('Error converting rotated image to file:', error);
      return null;
    }
  };

  function getExtensionFromMimeType(mimeType) {
    const mimeToExtension = {
      'image/jpeg': 'jpg',
      'image/png': 'png',
      'image/gif': 'gif',
      'image/bmp': 'bmp',
      'image/svg+xml': 'svg',
      'image/webp': 'webp'
      // Add more MIME types and their extensions as needed
    };

    return mimeToExtension[mimeType] || '';
  }
  const [openMultiEdit, setOpenMultiEdit] = React.useState(false);
  const [editimgurl, setEditimgurl] = React.useState(null);
  const [editimgurlOrg, setEditimgurlOrg] = React.useState(null);
  const [editimg, setEditimg] = React.useState(null);

  const handleOpenMultiEdit = (file, index) => {
    setOpenMultiEdit(true);
    setEditimg({
      file,
      index
    });
    setEditimgurl(URL.createObjectURL(file));
    setEditimgurlOrg(URL.createObjectURL(file));
  };

  const handleCloseMultiEdit = async () => {
    setOpenMultiEdit(false);

    // Use map to create an array of promises to update the image at the desired index
    const updatedDataImg = await Promise.all(
      dataimg.map(async (file, index) => {
        // If the index matches the one you want to edit, update the file
        if (index === editimg.index) {
          const updatedFile = await urlToFile2(); // Wait for the file update to complete
          return updatedFile; // Return the new file
        }
        return file; // For other files, return them unchanged
      })
    );

    // Now set the updated array to the state
    setDataimg(updatedDataImg);
  };
  const handleVideoUpload = fileList => {
    if (fileList.length > 0) {
      const file = fileList[fileList.length - 1];
      const allowedExtensions = ['mp4', 'webm', 'ogg'];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (allowedExtensions.includes(fileExtension)) {
        const videoURL = URL.createObjectURL(file.blobFile);
        setData5({
          ...data5,
          threeDview: file.blobFile
        });
        console.log('Video URL:', videoURL);
        setData51(videoURL); // Store the URL of the uploaded video
        toaster.push(
          <Message showIcon type="success">
            Video Upload Successfully
          </Message>,

          { placement: 'topCenter' }
        );
      } else {
        toaster.push(
          <Message showIcon type="error">
            Please upload a video in MP4, WebM, or OGG format
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  };
  const handleDeleteImage = () => {
    setEditCount(1);
    setFileInfo(null);
    setData5({
      ...data5,
      CoverImage: null
    });
  };

  const handleDeleteImage2 = () => {
    setEditimgurl(null);
    handleDeleteImagebyName(editimg.file.name);
    handleCloseMultiEdit();
  };
  const handleDeleteImagebyName = name => {
    setNum1(1);

    // console.log(`deleting ${name}`);
    setDataimg(() => {
      const updatedDataimg = dataimg.filter(item => item.name != name);
      const countELE = document.getElementById('file-count');
      if (updatedDataimg.length > 0) {
        countELE.textContent = `${updatedDataimg.length} file${updatedDataimg.length === 1 ? '' : 's'
          }`;
      } else {
        countELE.textContent = '0 files';
      }
      return updatedDataimg;
    });
  };
  const [color1, setColor1] = useState('#FFFFFF');

  const handleRemoveBackground = async e => {
    if (!bgChangeLoading) {
      e.preventDefault();
      setLoading1(true);

      if (!fileInfo) {
        alert('Please upload an image.');
        return;
      }

      if (!color1) {
        alert('Please select a color.');
        return;
      }

      // setUploading(true);

      // const fileInput = fileInfo; // Image data
      // const colorInput = color1; // Color code
      // console.log("Cover Image :",data5.CoverImage)

      let imageBlob = data5.CoverImage;
      const fileInput = fileInfo; // Image data
      const colorInput = color1; // Color code
      // console.log("Cover Image :", data5.CoverImage)

      if (!(data5.CoverImage instanceof File)) {
        // console.log("It's not a File, converting to Blob.");

        // Fetch the image from the URL
        const response = await fetch(data5.CoverImage);
        const blob = await response.blob();

        // Create a File from the Blob (you need to specify the filename and MIME type)
        const file = new File([blob], name, { type: blob.type });

        // console.log("Converted File:", file);

        // If you want the URL of the Blob (Blob URL) for further use:
        const blobUrl = URL.createObjectURL(blob);
        // console.log("Blob URL:", blobUrl);
        setData5(prevData => ({
          ...prevData,
          CoverImage: file
        }));

        // You can now use `file` as a File object
        imageBlob = file;
      }

      const formData = new FormData();
      formData.append('image', imageBlob);
      formData.append('color', '#FFFFFF');

      // fetch(`http://${hostname}${Port.smartsearchip}/api/change_image_background`, {
      // fetch(`http://110.227.189.169:4044/api/change_image_background`, {
      fetch(`https://bgreml.growwizo.com/change_image_background/`, {
        method: 'POST',
        body: formData
      })
        .then(response => response.blob())
        .then(imageBlob => {
          // Create a Blob URL for the returned image
          const imageUrl = URL.createObjectURL(imageBlob);

          // Update the uploader's preview and data5 state
          setFileInfo(imageUrl);
          setData5(prevData => ({
            ...prevData,
            CoverImage: imageBlob
          }));

          // Display the result in the 'result' div
          // const resultImg = document.createElement('img');
          // resultImg.src = imageUrl;
          // resultImg.classList.add('result-img');

          // document.getElementById('result').innerHTML = '';
          // document.getElementById('result').appendChild(resultImg);

          setTimeout(() => {
            setLoading1(false);
            setEditCount(1);
            toaster.push(
              <Message showIcon type="success">
                Background Remove Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          }, 2000);
        })
        .catch(error => {
          toaster.push(
            <Message showIcon type="error">
              Something went wrong please try again.
            </Message>,
            { placement: 'topCenter' }
          );
          setLoading1(false);
        });
    }
  };

  const handleRemoveBackground2 = async e => {
    // setColor1('#FFFFFF');
    setLoading2(true);
    e.preventDefault();
    setBgChangeLoading(true);
    if (!editimgurl) {
      alert('Please upload an image.');
      return;
    }

    if (!color1) {
      alert('Please select a color.');
      return;
    }

    // setUploading(true); // Show loading spinner

    try {
      // Fetch the image as a Blob
      const imageBlob = await fetch(editimgurl).then(response => response.blob());
      const colorInput = color1; // Selected color

      const formData = new FormData();
      formData.append('image', imageBlob, 'image.jpg'); // Append the Blob with a file name
      formData.append('color', '#FFFFFF'); // Append the color input

      // Make the API request to change the background
      const response = await fetch(
        // `http://${hostname}${Port.smartsearchip}/api/change_image_background`,
        // `http://110.227.189.169:4044/api/change_image_background`,
        `https://bgreml.growwizo.com/change_image_background/`,

        {
          method: 'POST',
          body: formData
        }
      );

      if (!response.ok) {
        throw new Error('Failed to change background.');
      }
      const changedBackgroundBlob = await response.blob();
      const changedBackgroundURL = URL.createObjectURL(changedBackgroundBlob);

      // Update state with the new image URL
      setEditimgurl(changedBackgroundURL);
      setBgChangeLoading(false);
      setLoading2(false);
      toaster.push(
        <Message showIcon type="success">
          Background Change Successfully.
        </Message>,
        { placement: 'topCenter' }
      );
    } catch (error) {
      toaster.push(
        <Message showIcon type="error">
          Something went wrong please try again.
        </Message>,
        { placement: 'topCenter' }
      );
      setBgChangeLoading(false);
    }
  };
  const handleColorChange = e => {
    // console.log("coolller " , e.target.value)
    setColor1(e.target.value);
  };

  const handleSubmit = async e => {
    if (!loading1) {
      e.preventDefault();
      setBgChangeLoading(true);

      if (!fileInfo) {
        alert('Please upload an image.');
        return;
      }

      if (!color1) {
        alert('Please select a color.');
        return;
      }

      // setUploading(true);

      // const fileInput = fileInfo; // Image data
      // const colorInput = color1; // Color code
      // console.log("Cover Image :",data5.CoverImage)

      let imageBlob = data5.CoverImage;
      const fileInput = fileInfo; // Image data
      const colorInput = color1; // Color code
      // console.log("Cover Image :", data5.CoverImage)

      if (!(data5.CoverImage instanceof File)) {
        // console.log("It's not a File, converting to Blob.");

        // Fetch the image from the URL
        const response = await fetch(data5.CoverImage);
        const blob = await response.blob();

        // Create a File from the Blob (you need to specify the filename and MIME type)
        const file = new File([blob], name, { type: blob.type });

        // console.log("Converted File:", file);

        // If you want the URL of the Blob (Blob URL) for further use:
        const blobUrl = URL.createObjectURL(blob);
        // console.log("Blob URL:", blobUrl);
        setData5(prevData => ({
          ...prevData,
          CoverImage: file
        }));

        // You can now use `file` as a File object
        imageBlob = file;
      }

      const formData = new FormData();
      formData.append('image', imageBlob);
      formData.append('color', colorInput);

      // fetch(`http://${hostname}${Port.smartsearchip}/api/change_image_background`, {
      //  fetch(`http://110.227.189.169:4044/api/change_image_background`, {
      fetch(`https://bgreml.growwizo.com/change_image_background/`, {
        method: 'POST',
        body: formData
      })
        .then(response => response.blob())
        .then(imageBlob => {
          // Create a Blob URL for the returned image
          const imageUrl = URL.createObjectURL(imageBlob);

          // Update the uploader's preview and data5 state
          setFileInfo(imageUrl);
          setData5(prevData => ({
            ...prevData,
            CoverImage: imageBlob
          }));

          // Display the result in the 'result' div
          // const resultImg = document.createElement('img');
          // resultImg.src = imageUrl;
          // resultImg.classList.add('result-img');

          // document.getElementById('result').innerHTML = '';
          // document.getElementById('result').appendChild(resultImg);

          setTimeout(() => {
            setBgChangeLoading(false);
            setEditCount(1);
            toaster.push(
              <Message showIcon type="success">
                Background Change Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          }, 2000);
        })
        .catch(error => {
          toaster.push(
            <Message showIcon type="error">
              Something went wrong please try again.
            </Message>,
            { placement: 'topCenter' }
          );
          setBgChangeLoading(false);
        });
    }
  };
  const [bgChangeLoading, setBgChangeLoading] = useState(false);
  const handleSubmit1 = async e => {
    e.preventDefault();
    setBgChangeLoading(true);
    if (!editimgurl) {
      alert('Please upload an image.');
      return;
    }

    if (!color1) {
      alert('Please select a color.');
      return;
    }

    // setUploading(true); // Show loading spinner

    try {
      // Fetch the image as a Blob
      const imageBlob = await fetch(editimgurl).then(response => response.blob());
      const colorInput = color1; // Selected color

      const formData = new FormData();
      formData.append('image', imageBlob, 'image.jpg'); // Append the Blob with a file name
      formData.append('color', colorInput); // Append the color input

      // Make the API request to change the background
      const response = await fetch(
        // `http://${hostname}${Port.smartsearchip}/api/change_image_background`,
        // `http://110.227.189.169:4044/api/change_image_background`,
        `https://bgreml.growwizo.com/change_image_background/`,
        {
          method: 'POST',
          body: formData
        }
      );

      if (!response.ok) {
        throw new Error('Failed to change background.');
      }
      const changedBackgroundBlob = await response.blob();
      const changedBackgroundURL = URL.createObjectURL(changedBackgroundBlob);

      // Update state with the new image URL
      setEditimgurl(changedBackgroundURL);
      setBgChangeLoading(false);
      toaster.push(
        <Message showIcon type="success">
          Background Change Successfully.
        </Message>,
        { placement: 'topCenter' }
      );
    } catch (error) {
      toaster.push(
        <Message showIcon type="error">
          Something went wrong please try again.
        </Message>,
        { placement: 'topCenter' }
      );
      setBgChangeLoading(false);
    }
  };

  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const handleMultiImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    // setUpdateId('');

    const fileInput = e.target;
    const fileCountSpan = fileInput.nextElementSibling?.nextElementSibling;

    const uploadedImages = Array.from(e.target.files || []) as File[];
    const allowedExtensions = ['jpg', 'jpeg'];

    const validImages = uploadedImages.filter(file => {
      const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
      return allowedExtensions.includes(fileExtension);
    });

    const watermarkEnabled = compndata[0]?.attributes?.WMark === true;

    validImages.forEach(file => {
      const fileReader = new FileReader();
      fileReader.onload = event => {
        const img = new Image();
        img.src = event.target?.result as string;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = img.width;
          canvas.height = img.height;

          ctx?.drawImage(img, 0, 0);

          if (watermarkEnabled && watermarkImg) {
            const watermarkUrl = `${globalIP}${compndata[0]?.attributes?.WaterMark?.data?.attributes?.url}`;
            const watermarkImgTag = new Image();
            watermarkImgTag.crossOrigin = 'anonymous';
            watermarkImgTag.src = watermarkUrl;

            watermarkImgTag.onload = () => {
              const watermarkWidth = img.width * 0.3;
              const watermarkHeight =
                (watermarkImgTag.height / watermarkImgTag.width) * watermarkWidth;

              const watermarkX = (canvas.width - watermarkWidth) / 2;
              const watermarkY = (canvas.height - watermarkHeight) / 2;

              ctx!.globalAlpha = 0.3;
              ctx?.drawImage(
                watermarkImgTag,
                watermarkX,
                watermarkY,
                watermarkWidth,
                watermarkHeight
              );

              finalizeWatermarkedImage(canvas, file.type, file.name);
            };
          } else {
            finalizeWatermarkedImage(canvas, file.type, file.name);
          }
        };
      };
      fileReader.readAsDataURL(file);
    });

    const finalizeWatermarkedImage = (
      canvas: HTMLCanvasElement,
      fileType: string,
      fileName: string
    ) => {
      setLoadingMultipleimg(true);

      canvas.toBlob(
        blob => {
          if (blob) {
            const watermarkedFile = new File([blob], fileName, { type: fileType });

            setDataimg(prevFiles => [...prevFiles, watermarkedFile]);

            toaster.push(<Message type="success">File processed successfully</Message>);
            setLoadingMultipleimg(false);
          }
        },
        fileType,
        0.6
      ); // full quality
    };

    const invalidImages = uploadedImages.filter(file => !validImages.includes(file));
    invalidImages.forEach(file => {
      toaster.push(<Message type="error">{file.name} is not a valid jpg/jpeg file</Message>);
    });

    setNum1(1);
  };

  const handleDragStart = (index: number) => {
    setDraggedIndex(index);
  };

  // Handle drag over (required to allow dropping)
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDrop = (index: number) => {
    if (draggedIndex === null) return;

    const updatedImages = [...dataimg];
    const draggedItem = updatedImages[draggedIndex];
    updatedImages.splice(draggedIndex, 1);
    updatedImages.splice(index, 0, draggedItem);
    setNum1(1);
    // setNum(1);
    console.log('dataimg updated', dataimg);
    setDataimg(updatedImages);
    setDraggedIndex(null); // Reset drag index
  };

  const [objectUrls, setObjectUrls] = useState([]);

  useEffect(() => {
    const sorted = [...dataimg].sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );
    const urls = sorted.map(file => URL.createObjectURL(file));
    setObjectUrls(urls);

    return () => {
      urls.forEach(url => URL.revokeObjectURL(url));
    };
  }, [dataimg]);

  useEffect(() => {
    // Preload watermark image when the component mounts
    preloadWatermarkImage()
      .then(img => {
        setWatermarkImg(img);
        console.log('Watermark image loaded successfully');
      })
      .catch(err => {
        console.error(err);
      });
  }, [compndata]); // Empty dependency array means it runs only once when the component mounts

  return (
    <FlexboxGrid.Item as={Col} colspan={24} md={4}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        {/* Warning Text */}
        <p style={{ color: 'red', margin: 0 }}>(Image required only jpg)*</p>

        {/* Edit Icon - overlay on top right */}
        <IconButton
          size="md"
          icon={<EditIcon />}
          onClick={handleopenImageEditModal}
          active
          className="edit-icon"
          disabled={processing}
          style={{
            position: 'absolute',
            right: 0,
            zIndex: 10
          }}
        />
        <AntdImageUploader
          watermarkImg={watermarkImg}
          compndata={compndata}
          finalizeCanvas={finalizeCanvas}
          rotationDegrees={rotationDegrees}
          setName={setName}
          setProcessing={setProcessing}
          initialImage={orginalImg}
        />
      </div>
      {/* <Uploader
        onChange={handleImageUpload}
        fileListVisible={false}
        accept="image/jpeg,image/jpg"
        listType="picture"
        action={null} // Change from '' to null
        autoUpload={false} // Add this line
        shouldUpload={() => false}
        // action={''}
        draggable
      >
        <button style={{ width: 255, height: 255 }}>
          {uploading ? (
            <Loader backdrop content="loading..." vertical />
          ) : fileInfo ? (
            <img
              src={fileInfo}
              style={{ transform: `rotate(${rotationDegrees}deg)`, objectFit: 'contain' }}
              width="100%"
              height="100%"
            />
          ) : (
            <CameraRetroIcon style={{ fontSize: 80 }} />
          )}
        </button>
      </Uploader> */}
      {/* <div id="result" style={{width:'100px', height:'100px'}}></div> */}
      <Modal open={openImageEditModal} onClose={handleCloseImageEditModal} backdrop={'static'}>
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FlexboxGrid justify="space-around">
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <span style={{ color: '#005c80', fontSize: '11px' }}>
                {' '}
                <b>( Important Instructions* )</b>
              </span>{' '}
              <br />
              <span style={{ fontSize: '13px', gap: '5px' }}>
                {' '}
                <b>Step:1</b> <p>Remove your image background*</p>{' '}
              </span>{' '}
              <br />
              <span style={{ fontSize: '13px', gap: '5px' }}>
                {' '}
                <b>Step:2</b> <p>Rotate your Image*</p>
              </span>{' '}
              <br />
              <span style={{ fontSize: '13px', gap: '5px' }}>
                {' '}
                <b>Step:3</b> <p>You can save your rotate Image*</p>
              </span>{' '}
              <br />
              <span style={{ fontSize: '13px', gap: '5px' }}>
                {' '}
                <b>Step:4</b> <p>Re-upload the downloaded image*</p>
              </span>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={16}>
              <div
                style={{
                  display: 'flex',
                  // position: 'absolute',
                  zIndex: '1',
                  fontSize: '17px',
                  marginLeft: '36px'
                }}
              >
                <div
                  style={{
                    backgroundColor: 'rgb(216 216 219)',
                    padding: '5px',
                    paddingTop: '1px',
                    margin: '5px',
                    borderRadius: '10px',
                    cursor: 'pointer'
                  }}
                >
                  <Whisper
                    placement="topEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>Reset</Tooltip>}
                  >
                    <Icon
                      as={UndoIcon}
                      onClick={() => {
                        if (editCount !== 0) {
                          setFileInfo(orginalImg);
                        }
                      }}
                    />
                  </Whisper>
                </div>
                <div
                  style={{
                    backgroundColor: 'rgb(216 216 219)',
                    padding: '5px',
                    paddingTop: '1px',
                    margin: '5px',
                    borderRadius: '10px',
                    cursor: 'pointer'
                  }}
                >
                  <Whisper
                    placement="topEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>Crop Image</Tooltip>}
                  >
                    <Icon as={ZoomoutIcon} onClick={handleCropping} />
                  </Whisper>
                </div>
                <div
                  style={{
                    backgroundColor: 'rgb(216 216 219)',
                    padding: '5px',
                    paddingTop: '1px',
                    margin: '5px',
                    borderRadius: '10px',
                    cursor: 'pointer'
                  }}
                >
                  <Whisper
                    placement="topEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>Remove Background</Tooltip>}
                  >
                    {loading1 ? (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          paddingTop: '6px'
                        }}
                      >
                        <Loader />
                      </div>
                    ) : (
                      <Icon as={BlockIcon} onClick={handleRemoveBackground} />
                    )}
                  </Whisper>
                </div>

                <div
                  style={{
                    backgroundColor: 'rgb(216 216 219)',
                    padding: '5px',
                    paddingTop: '1px',
                    margin: '5px',
                    borderRadius: '10px',
                    cursor: 'pointer'
                  }}
                >
                  <Whisper
                    placement="topEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>Rotate Image</Tooltip>}
                  >
                    <Icon as={ReloadIcon} onClick={handleRotateImage} />
                  </Whisper>
                </div>
                {/* <div
                  style={{
                    backgroundColor: 'rgb(216 216 219)',
                    padding: '5px',
                    paddingTop: '1px',
                    margin: '5px',
                    borderRadius: '10px',
                    cursor: 'pointer'
                  }}
                >
                  <Whisper
                    placement="topEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>Remove Image</Tooltip>}
                  >
                    <Icon as={TrashIcon} onClick={handleDeleteImage} />
                  </Whisper>
                </div> */}
                {(user.PRDpicdwnld === true || user.Category === 'Admin') && (
                  <div
                    style={{
                      backgroundColor: 'rgb(216 216 219)',
                      padding: '5px',
                      paddingTop: '1px',
                      margin: '5px',
                      borderRadius: '10px',
                      cursor: 'pointer'
                    }}
                  >
                    <Whisper
                      placement="topEnd"
                      controlId="control-id-hover"
                      trigger="hover"
                      speaker={<Tooltip>Download Image</Tooltip>}
                    >

                      {imageDownloading ? (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingTop: '6px'
                          }}
                        >
                          <Loader />
                        </div>
                      ) : (
                        <Icon as={SortDownIcon} onClick={handleDownloadImage} />
                      )}
                      {/* <Icon as={SortDownIcon} onClick={handleDownloadImage} /> */}
                    </Whisper>
                  </div>
                )}
                <div style={{ display: 'flex', border: '1px solid grey', borderRadius: '7px' }}>
                  <div style={{ margin: '5px' }}>
                    <input
                      type="color"
                      value={color1}
                      onChange={handleColorChange}
                      style={{
                        marginTop: 1,
                        borderRadius: 7,
                        width: '27px',
                        cursor: 'pointer'
                      }}
                    />
                  </div>
                  <div
                    style={{
                      backgroundColor: 'rgb(216 216 219)',
                      padding: '5px',
                      paddingTop: '1px',
                      margin: '5px',
                      borderRadius: '10px',
                      cursor: 'pointer'
                    }}
                  >
                    <Whisper
                      placement="topEnd"
                      controlId="control-id-hover"
                      trigger="hover"
                      speaker={<Tooltip>Change Background Color</Tooltip>}
                    >
                      {bgChangeLoading ? (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingTop: '6px'
                          }}
                        >
                          <Loader />
                        </div>
                      ) : (
                        <Icon
                          as={ScatterIcon}
                          style={{ paddingTop: '4px' }}
                          onClick={handleSubmit}
                        />
                      )}
                    </Whisper>
                  </div>
                </div>
              </div>

              <Stack justifyContent="center">
                <button style={{ width: 255, height: 255, backgroundColor: 'white' }}>
                  {uploading && <Loader backdrop center />}
                  {fileInfo ? (
                    isCropping ? (
                      <div>
                        {/* <p>{ fileInfo }</p> */}
                        <Cropper
                          handleCropping={handleCropping}
                          imageToCrop={fileInfo}
                          croppedImage={(value: any) => {
                            setFileInfo(value);
                            // console.log('CROPED IMAGE :', value);
                          }}
                        />
                      </div>
                    ) : (
                      <img
                        src={fileInfo}
                        width="100%"
                        height="100%"
                        style={{
                          transform: `rotate(${rotationDegrees}deg)`,
                          objectFit: 'contain'
                        }}
                      />
                    )
                  ) : (
                    <CameraRetroIcon style={{ fontSize: 80 }} />
                  )}
                </button>
              </Stack>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Modal.Body>
        <Modal.Footer>
          <Button
            appearance="default"
            loading={closingopenEditModal}
            active
            onClick={handleCloseImageEditModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal open={openMultiEdit} onClose={handleCloseMultiEdit} backdrop={'static'}>
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FlexboxGrid justify="space-around">
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <span style={{ color: '#005c80', fontSize: '11px' }}>
                {' '}
                <b>( Important Instructions multi image* )</b>
              </span>{' '}
              <br />
              <span style={{ fontSize: '13px', gap: '5px' }}>
                {' '}
                <b>Step:1</b> <p>Remove your image background*</p>{' '}
              </span>{' '}
              <br />
              <span style={{ fontSize: '13px', gap: '5px' }}>
                {' '}
                <b>Step:2</b> <p>Rotate your Image*</p>
              </span>{' '}
              <br />
              <span style={{ fontSize: '13px', gap: '5px' }}>
                {' '}
                <b>Step:3</b> <p>You can save your rotate Image*</p>
              </span>{' '}
              <br />
              <span style={{ fontSize: '13px', gap: '5px' }}>
                {' '}
                <b>Step:4</b> <p>Re-upload the downloaded image*</p>
              </span>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={16}>
              <div
                style={{
                  display: 'flex',
                  // position: 'absolute',
                  zIndex: '1',
                  fontSize: '17px',
                  marginLeft: '36px'
                }}
              >
                <div
                  style={{
                    backgroundColor: 'rgb(216 216 219)',
                    padding: '5px',
                    paddingTop: '1px',
                    margin: '5px',
                    borderRadius: '10px',
                    cursor: 'pointer'
                  }}
                >
                  <Whisper
                    placement="topEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>Reset</Tooltip>}
                  >
                    <Icon as={UndoIcon} onClick={() => setEditimgurl(editimgurlOrg)} />
                  </Whisper>
                </div>
                <div
                  style={{
                    backgroundColor: 'rgb(216 216 219)',
                    padding: '5px',
                    paddingTop: '1px',
                    margin: '5px',
                    borderRadius: '10px',
                    cursor: 'pointer'
                  }}
                >
                  <Whisper
                    placement="topEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>Crop Image</Tooltip>}
                  >
                    <Icon as={ZoomoutIcon} onClick={handleCropping} />
                  </Whisper>
                </div>
                <div
                  style={{
                    backgroundColor: 'rgb(216 216 219)',
                    padding: '5px',
                    paddingTop: '1px',
                    margin: '5px',
                    borderRadius: '10px',
                    cursor: 'pointer'
                  }}
                >
                  <Whisper
                    placement="topEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>Remove Background</Tooltip>}
                  >
                    {loading2 ? (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          paddingTop: '6px'
                        }}
                      >
                        <Loader />
                      </div>
                    ) : (
                      <Icon as={BlockIcon} onClick={handleRemoveBackground2} />
                    )}
                  </Whisper>
                </div>

                <div
                  style={{
                    backgroundColor: 'rgb(216 216 219)',
                    padding: '5px',
                    paddingTop: '1px',
                    margin: '5px',
                    borderRadius: '10px',
                    cursor: 'pointer'
                  }}
                >
                  <Whisper
                    placement="topEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>Rotate Image</Tooltip>}
                  >
                    <Icon as={ReloadIcon} onClick={handleRotateImage2} />
                  </Whisper>
                </div>
                {/* <div
                                    style={{
                                        backgroundColor: 'rgb(216 216 219)',
                                        padding: '5px',
                                        paddingTop: '1px',
                                        margin: '5px',
                                        borderRadius: '10px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <Whisper
                                        placement="topEnd"
                                        controlId="control-id-hover"
                                        trigger="hover"
                                        speaker={<Tooltip>Remove Image</Tooltip>}
                                    >
                                        <Icon as={TrashIcon} onClick={handleDeleteImage2} />
                                    </Whisper>
                                </div> */}
                {(user.PRDpicdwnld === true || user.Category === 'Admin') && (
                  <div
                    style={{
                      backgroundColor: 'rgb(216 216 219)',
                      padding: '5px',
                      paddingTop: '1px',
                      margin: '5px',
                      borderRadius: '10px',
                      cursor: 'pointer'
                    }}
                  >
                    <Whisper
                      placement="topEnd"
                      controlId="control-id-hover"
                      trigger="hover"
                      speaker={<Tooltip>Download Image</Tooltip>}
                    >
                      <Icon as={SortDownIcon} onClick={handleDownloadImage2} />
                    </Whisper>
                  </div>
                )}
                <div style={{ display: 'flex', border: '1px solid grey', borderRadius: '7px' }}>
                  <div style={{ margin: '5px' }}>
                    <input
                      type="color"
                      value={color1}
                      onChange={handleColorChange}
                      style={{
                        marginTop: 1,
                        borderRadius: 7,
                        width: '27px',
                        cursor: 'pointer'
                      }}
                    />
                  </div>
                  <div
                    style={{
                      backgroundColor: 'rgb(216 216 219)',
                      padding: '5px',
                      paddingTop: '1px',
                      margin: '5px',
                      borderRadius: '10px',
                      cursor: 'pointer'
                    }}
                  >
                    <Whisper
                      placement="topEnd"
                      controlId="control-id-hover"
                      trigger="hover"
                      speaker={<Tooltip>Change Background Color</Tooltip>}
                    >
                      {bgChangeLoading ? (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                        >
                          <Loader style={{ marginTop: '4px' }} />
                        </div>
                      ) : (
                        <Icon as={ScatterIcon} onClick={handleSubmit1} />
                      )}
                    </Whisper>
                  </div>
                </div>
              </div>

              <Stack justifyContent="center">
                <button style={{ width: 255, height: 255, backgroundColor: 'white' }}>
                  {uploading && <Loader backdrop center />}
                  {editimgurl ? (
                    isCropping ? (
                      <div>
                        {/* <p>{ editimgurl }</p> */}
                        <Cropper
                          handleCropping={handleCropping}
                          imageToCrop={editimgurl}
                          croppedImage={(value: any) => setEditimgurl(value)}
                        />
                      </div>
                    ) : (
                      <img
                        src={editimgurl}
                        width="100%"
                        height="100%"
                        style={{
                          transform: `rotate(${rotationDegrees2}deg)`,
                          objectFit: 'contain'
                        }}
                      />
                    )
                  ) : (
                    <CameraRetroIcon style={{ fontSize: 80 }} />
                  )}
                </button>
              </Stack>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Modal.Body>
        <Modal.Footer>
          <Button appearance="default" active onClick={handleCloseMultiEdit}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Stack direction="column">
        <Stack style={{ gap: '5px' }}>
          <Uploader
            autoUpload={false}
            onChange={fileList => handleVideoUpload(fileList)}
            fileList={[]}
            accept="video/mp4,video/webm,video/ogg"
            action=""
          >
            {/* You can customize the appearance of the Uploader button using CSS */}
            <button
              style={{
                width: 95,
                height: 38,
                borderRadius: ' 5px',
                marginTop: '7px',
                marginLeft: '40px'
              }}
            >
              <span>Upload video</span>
            </button>
          </Uploader>

          {loadingMultipleimg ? (
            <Button
              style={{
                marginLeft: '10px'
              }}
              loading={loadingMultipleimg}
            >
              {' '}
              More Images
            </Button>
          ) : (
            <Stack className="moreImage">
              <label>
                <input
                  type="file"
                  multiple
                  onChange={handleMultiImageUpload}
                  accept="image/jpeg,image/jpg"
                  className="img-btn"
                />
                {/* Display Image List */}

                <span className="icon">More Images</span>
                <span className="file-count" id="file-count">
                  {/* {dataLength > 0 ? `${dataLength} files` : `${dataimg.length} files`} */}
                  {dataimg ? `${dataimg.length} files` : `0 files`}
                </span>
              </label>
            </Stack>
          )}
        </Stack>
        {/* Display uploaded images */}
        {
          <div
            style={{
              display: 'flex',
              flexWrap: 'nowrap', // Prevent wrapping to enable horizontal scrolling
              marginTop: '2px',
              width: '18rem',
              gap: '15px',
              maxWidth: '100%', // Set maximum width for horizontal scrolling
              overflowX: 'auto', // Enable horizontal scrolling
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'rgba(0,0,0,0.5) transparent' // For Firefox
            }}
          >
            <style>
              {`
                /* Webkit scrollbar styling */
                div::-webkit-scrollbar {
                  height: 6px; /* Horizontal scrollbar height */
                }
                div::-webkit-scrollbar-thumb {
                  background: rgba(0, 0, 0, 0.5); 
                  border-radius: 3px;
                }
                div::-webkit-scrollbar-thumb:hover {
                  background: rgba(0, 0, 0, 0.7);
                }
                div::-webkit-scrollbar-track {
                  background: transparent;
                }
              `}
            </style>
            {[...dataimg]
              .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
              .map((file, index) => (
                <div
                  key={index}
                  className="image-preview"
                  style={{ display: 'flex', position: 'relative' }}
                >
                  <div
                    style={{ display: 'flex', alignItems: 'center', position: 'relative' }}
                    draggable
                    onDragStart={() => handleDragStart(index)}
                    onDragOver={handleDragOver}
                    onDrop={() => handleDrop(index)}
                    onMouseEnter={() => setHovered(index)}
                    onMouseLeave={() => setHovered(null)}
                  >
                    <img
                      src={objectUrls[index]}
                      alt={`Uploaded Preview ${index + 1}`}
                      style={{
                        maxWidth: '75px',
                        maxHeight: '75px',
                        objectFit: 'contain',
                        height: '80px',
                        width: '80px',
                        borderRadius: '5px'
                      }}
                    />
                    {hovered === index && (
                      <>
                        <IconButton
                          appearance="primary"
                          size="xs"
                          style={{ position: 'absolute', top: '0px', left: '0px' }}
                          icon={<EditIcon />}
                          onClick={() => handleOpenMultiEdit(file, index)}
                          active
                          className="edit-icon"
                        />
                        <IconButton
                          icon={<TrashIcon />}
                          appearance="primary"
                          size="xs"
                          color="red"
                          style={{ position: 'absolute', top: '0px', right: '0px' }}
                          onClick={() => handleDeleteImagebyName(file.name)}
                        />
                      </>
                    )}
                  </div>
                </div>
              ))}
          </div>
        }
        {data51 && <video src={data51} controls width="300" height="auto" />}
      </Stack>
    </FlexboxGrid.Item>
  );
};

export default memo(ImageSection);
